export function userQueryKey(userId?: number) {
  return { userId };
}
